import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";

export function SetPasswordDialog({ open, onOpenChange, target, password, setPassword, onSubmit }) {
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="bg-card border-border max-w-sm">
                <DialogHeader>
                    <DialogTitle style={{ fontFamily: "Outfit" }}>Set Password</DialogTitle>
                </DialogHeader>
                <div className="space-y-3">
                    <p className="text-sm text-muted-foreground">
                        Set a new password for <span className="font-medium text-foreground">{target?.name}</span>
                        <br /><span className="text-xs">{target?.email}</span>
                    </p>
                    <div className="space-y-1">
                        <Label className="text-xs">New Password</Label>
                        <Input
                            data-testid="admin-set-pw-input"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="At least 6 characters"
                            className="bg-background border-border"
                        />
                    </div>
                </div>
                <DialogFooter>
                    <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
                    <Button data-testid="admin-set-pw-submit" onClick={onSubmit} style={{ backgroundColor: "#4A7AB5" }}>
                        Update Password
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
